import { jsx } from "panel";
import { hasSlot } from "common/util/dom";
import { StickyPlaceholderEl } from "common/widgets/sticky-placeholder";
import { AddEntryHeader } from "./components/add-row-from-header";
import { AddEntryRow } from "./components/add-row";
import { RowLabelType } from "./types";
const EntryRendererFactory = function({ entry, el }) {
  const rowProps = { section: el, index: entry.index, entry: entry.entry };
  return entry.template.call(entry, rowProps);
};
export function template() {
  const hasNewUI = this.hasNewQBUI();
  const hasNewHeader = hasNewUI && (hasSlot(this, `header-items`) || this.attr(`section-title`));
  const hasStickyHeader = this.helpers.isStickyHeader();
  const showAddButton = this.helpers.showAddButton() && !this.attr(`disable-add-entry`) && !hasNewHeader;
  const displayFooter = hasSlot(this, `footer-items`) || showAddButton;
  const showLabels = this.attr(`row-label-type`) !== RowLabelType.None && this.attr(`row-limit`) !== 1;
  const dropAreasCount = this.helpers.allowDropAreas(this.state.draggingOverStepIndex).size;
  const canDrop = !this.getEntries().length && dropAreasCount > 0;
  const isEmpty = this.helpers.getEntries().length === 0;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-entry-section",
    class: {
      "has-labels": showLabels,
      "is-empty": isEmpty,
      "is-draggable": this.attr(`row-draggable`),
      "for-new-metrics-mode": true,
      "for-new-ui": hasNewUI,
      "for-list-objects": !!this.params.listProperty
    },
    on: {
      mouseEnterContextMenu: () => this.helpers.handleContextMenuHoverChange(true),
      mouseLeaveContextMenu: () => this.helpers.handleContextMenuHoverChange(false)
    }
  }, hasStickyHeader && /* @__PURE__ */ jsx(StickyPlaceholderEl, {
    props: {
      stickyElm: this.helpers.getStickyHeaderElm()
    }
  }), hasNewHeader && /* @__PURE__ */ jsx(AddEntryHeader, {
    el: this
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-entry-section-body"
  }, this.getRows(true).map((entry) => /* @__PURE__ */ jsx(EntryRendererFactory, {
    entry,
    el: this
  }))), displayFooter && /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-entry-section-footer",
    class: { "is-empty": isEmpty }
  }, showAddButton && /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-add-entry-row",
    class: {
      "drop-indicator-above": this.state.draggingOverStepIndex === this.getEntries().length && canDrop
    },
    on: {
      dragleave: () => this.update({ draggingOverStepIndex: null }),
      drop: (ev) => canDrop && this.helpers.onEntryStepDrop(ev, 0),
      dragover: (ev) => this.helpers.onEntryStepDragOver(ev, 0)
    }
  }, /* @__PURE__ */ jsx(AddEntryRow, {
    hasContainedUI: this.hasNewQBUI() && !this.classList.contains(`contained-section`),
    hasPrefixRenderer: !!this.state.prefixRenderer,
    isDisabled: this.helpers.isAddingDisabled(),
    typeItems: this.helpers.getAddListTypeItems(),
    tooltipAttrs: this.helpers.getAddEntryButtonTooltipAttrs(),
    addEntryButtonLabel: this.attr(`add-entry-button-label`),
    addEntryMenuWidth: this.attr(`add-entry-menu-width`),
    isOpen: this.state.isTypeSelectOpen,
    onAutofocusableElAdded: this.helpers.onAutofocusableElAdded,
    onAddEntryRow: this.addEntryRow,
    onAddTypeSelectMenuChange: this.helpers.onAddTypeSelectMenuChange
  })), /* @__PURE__ */ jsx("slot", {
    attrs: { name: `footer-items` }
  })));
}
